// extracted by mini-css-extract-plugin
module.exports = {"standard":"FadeIn_standard__pYDxz","fadeInDown":"FadeIn_fadeInDown__savV7","top":"FadeIn_top__2fAlg"};